(function($) {

	///////
	//STICKY NAV
	$('.shula-nav').stick_in_parent({
    'parent' : $('body')
  });

	///////
	//OUR LOCATIONS MENU ITEM
	$('.shula-nav-btn-drop').hover(
		function() {
			$(this).addClass('active');
			$(this).find('button').attr('aria-expanded', 'true');
	  },
		function() {
		  $(this).removeClass('active');
			$(this).find('button').attr('aria-expanded', 'false');
	  }
	);

	$('.shula-nav-btn-drop').on('click', function() {
		$(this).toggleClass('active');
		$(this).find('button').attr('aria-expanded', function (i, val) {
			// If the current value is 'true', return 'false'. Otherwise, return 'true'.
			return val === 'true' ? 'false' : 'true';
		});
	});

	////////
	//Hamburger Menu --
	//Hamburger Vars
	var $menu = $('.shula-menu--main');
	var $locations = $('.shula-menu--locations');
	var $reservations = $('.shula-menu--reservations');
	var $groupDining = $('.shula-menu--groupDining');
	var $hamburger = $(".hamburger");
	var $logo = $('.custom-logo');

	//Animation Completed (fix for CSS hover animations messing /w these js animations)
	function hamburgerMenuAnimationComplete() {
		$menu.addClass('is-complete');
	}

	//Hamburger Animation Timeline
	var hamburgerMenuAnimation = new TimelineMax({paused:true, onComplete: hamburgerMenuAnimationComplete});
	hamburgerMenuAnimation
	  .set('.shula-menu__item', {x:20})
	  .to($menu, .5, {opacity:1, display:'block'})
		.staggerTo('.shula-menu__item', .5, {opacity:1, x:0}, 0.2, '-=.25')
		.to('.shula-menu__group', .5, {opacity:1, x:0}, '-=2');

	var locationMenuAnimation = new TimelineMax({paused:true});
	locationMenuAnimation
	  .to($locations, .5, {opacity:1, display:'block'});

	var reservationMenuAnimation = new TimelineMax({paused:true});
	reservationMenuAnimation
	  .to($reservations, .5, {opacity:1, display:'block'});

	var groupDiningMenuAnimation = new TimelineMax({paused:true});
	groupDiningMenuAnimation
	  .to($groupDining, .5, {opacity:1, display:'block'});

	//Hamburger Event
	$hamburger.on("click", function(e) {
		if (locationMenuAnimation.progress() !== 0) {
			locationMenuAnimation.reverse();
		} else {
			$('body').toggleClass("menu-is-active");
			$hamburger.toggleClass("is-active");
			if (hamburgerMenuAnimation.progress() == 0) {
				hamburgerMenuAnimation.play();
			} else {
				TweenMax.to($menu, 1, {opacity:0, display:'none'});
				hamburgerMenuAnimation.pause(0, true);
				$menu.removeClass('is-complete');
			}
		} 
	});

	$('.shula-menu--main .shula-menu-close').on('click', function(e){
		$hamburger.trigger('click');
	});

	$('.shula-menu--locations .shula-menu-close').on('click', function(e){
		$hamburger.trigger('click');
	});

	//Locations
	$('a[href="#locations"]').on('click', function(e){
		locationMenuAnimation.play();
	});

	//Reservations
	$('a[href="#reservations"]').on('click', function(e){
		$('body').addClass("menu-is-active");
		reservationMenuAnimation.play();
	});
	$('.shula-menu--reservations .shula-menu-close').on('click', function(){
		$('body').removeClass("menu-is-active");
		reservationMenuAnimation.reverse();
	});

	//Group Dining
	$('a[href="#groupDining"]').on('click', function(e){
		$('body').addClass("menu-is-active");
		groupDiningMenuAnimation.play();
	});
	$('.shula-menu--groupDining .shula-menu-close').on('click', function(){
		$('body').removeClass("menu-is-active");
		groupDiningMenuAnimation.reverse();
	});

	////////
	//Reveal on scroll -
	if ('IntersectionObserver' in window) {
		const boxes = document.querySelectorAll('.animate-on-scroll');
		//TweenMax.set(boxes, {opacity:0, y:50});

		const config = {
		  threshold: 0.5 };

		const tl = new TimelineMax();

		let observer = new IntersectionObserver(function (entries, self) {
		  entries.forEach(entry => {
		    if (entry.isIntersecting) {
		      let overlap = '-=0.3';

		      if (!tl.isActive()) {
		        overlap = '+=0';
		      }

		      tl.to(entry.target, .5, {opacity: 1, y:0}, overlap);
		      self.unobserve(entry.target);
		    }
		  });
		}, config);

		boxes.forEach(box => {
		  observer.observe(box);
		});
	}

 })( jQuery );
